<template lang="pug">
  .row
    .col
      span {{posicion}}
    .col
      span {{numeroauto}}
    .col
      span {{piloto}}
    .col
      span
        img(:src="`assets/images/logo-${marca}.png`")
    .col
      span(v-if="activetype === 'tiemposPrime'" ) {{tiemponeto}}
      span(v-if="activetype === 'tiemposAcumulados'" ) {{tiempoacumulado}}
    .col
      span {{velocidadpromedio}}
</template>
<script>
import {mapState} from 'vuex'

export default {
  props: {
    posicion: Number,
    numeroauto: Number,
    piloto: String,
    marca: String,
    tiemponeto: String,
    tiempoacumulado: String,
    velocidadpromedio: String
  },
  computed: {
    ...mapState({
      activetype: state => state.activeType,
    })
  }
}
</script>
<style lang="scss" scoped>
.col{
  text-align: center;
  img{
    max-height: 15px;
  }
}
</style>




